import { Fragment, h } from "preact";
import { TableComponent } from "../../../../components/table/styled";
import { IData, ITableDataPreview } from "../../interfaces/table";

export const TablePreview = ({ columns, data, loading }: ITableDataPreview) => {
  return (
    <>
      <TableComponent
        style={{ textAlign: "center" }}
        columns={columns}
        rowClassName={(record: IData | any) =>
          record.error === undefined ? "" : "color-error"
        }
        dataSource={data}
        loading={loading}
        bordered
        size="middle"
        scroll={{ x: "max-content" }}
      />
    </>
  );
};
